export default __webpack_public_path__ + "static/media/Belt of the Black Dragon.2c63fd0f.jpg";